import React from 'react';
import {Tooltip} from 'antd';
import Style from './index.module.scss';

interface Props {
    text: string;
    length?: number;
}
const Index = ({text, length = 8}: Props) => {
    return (
        <Tooltip title={text}>
            <div className={Style.text} style={{maxWidth: `${length}em`}}>
                {text}
            </div>
        </Tooltip>
    );
};

export default Index;
